import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function NotSharable() {
  return (
    <Box
      sx={{
        width: { xs: 300, md: 400 },
        backgroundColor: "#000",
        borderRadius: 2,
        p: 2,
      }}
    >
      <Typography>⇠ Toggle switch to share</Typography>
    </Box>
  );
}

export default NotSharable;
